var map = {
	"./01_error_code.json": "Py8D",
	"./02_timestamp.json": "Ui1f",
	"./03_digital_rule.json": "OGaA",
	"./04_rate_limits.json": "dz5L",
	"./05_system_time.json": "TbUJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OGFu";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/cswap/api/basic \.json$
// module id = OGFu
// module chunks = 3